// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"b48fd76d","29":"e8f44969","37":"3b0dcd7f","142":"bd51464c","459":"ecfc4dbe","535":"8c232c3e","623":"fb582996","732":"fbd01e4f","743":"4d367335","916":"67f17609","993":"01d6b922"}[chunkId] + ".js";
};